import React from 'react';
import IntoLogo from '../IntoLogo/IntoLogo';
import styles from './Header.module.scss';
import '../../styles/globals.scss';

export interface IHeader {
  children?: React.ReactNode;
  logoUrl: string;
  logoAriaLabel: string;
}

export default function Header({ children, logoUrl, logoAriaLabel }: IHeader) {
  return (
    <header className={styles.header}>
      <div className={['into-container', styles.headerContainer].join(' ')}>
        <a className={styles.intoLogo} href={logoUrl} aria-label={logoAriaLabel}>
          <IntoLogo />
        </a>
        <nav className={styles.headerLinks}>{children}</nav>
      </div>
    </header>
  );
}
